import { useEffect } from "react";

export const useMetisMenu = () => {
  useEffect(() => {
    if (window.jQuery && window.jQuery("#menu").length > 0) {
      try {
        window.jQuery("#menu").metisMenu();
      } catch (err) {
        console.error("MetisMenu init error:", err);
      }
    }
  }, []);
};

export const closeMobileNav = () => {
  if (window.innerWidth < 1200) {
    const mainWrapper = document.getElementById("main-wrapper");
    if (mainWrapper && mainWrapper.classList.contains("menu-toggle")) {
      mainWrapper.classList.remove("menu-toggle");
      const hamburgers = document.querySelectorAll(".hamburger");
      hamburgers.forEach((el) => el.classList.remove("is-active"));
    }
  }
};
